import { render } from "./rmxAtenderDestinos.vue?vue&type=template&id=58d22882"
import script from "./rmxAtenderDestinos.vue?vue&type=script&lang=js"
export * from "./rmxAtenderDestinos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/ceroPapel/cmp/rmxAtenderDestinos.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58d22882"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58d22882', __exports__)) {
    api.reload('58d22882', __exports__)
  }
  
  module.hot.accept("./rmxAtenderDestinos.vue?vue&type=template&id=58d22882", () => {
    api.rerender('58d22882', render)
  })

}


export default __exports__